import { IIconBase } from '..'

const externalLinkIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg width={width} height={height} viewBox='0 0 512.000000 512.000000'>
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M3474 4676 c-57 -57 -46 -154 21 -196 31 -19 49 -20 406 -20 l374 0
-822 -822 c-586 -586 -827 -834 -838 -861 -28 -68 10 -146 83 -166 77 -22 49
-48 934 837 l827 826 3 -387 3 -387 31 -31 c59 -58 157 -48 197 21 15 25 17
81 17 580 0 473 -2 555 -15 580 -32 61 -20 60 -631 60 l-556 0 -34 -34z'
        />
        <path
          d='M1105 4243 c-332 -70 -610 -349 -680 -683 -23 -107 -23 -2343 0
-2450 69 -326 326 -593 652 -676 l96 -24 1161 0 c1121 0 1164 1 1243 20 313
75 559 308 655 622 22 73 23 77 26 846 l3 773 -34 34 c-41 41 -90 52 -140 32
-76 -32 -71 18 -77 -817 -5 -684 -7 -749 -24 -800 -56 -172 -177 -315 -326
-389 -150 -74 -95 -71 -1325 -71 -1230 0 -1174 -3 -1325 71 -166 82 -297 251
-335 434 -22 104 -22 2236 0 2340 46 220 218 406 445 481 51 17 116 19 800 24
835 6 785 1 817 77 20 50 9 99 -32 140 l-33 33 -748 -1 c-624 0 -761 -3 -819
-16z'
        />
      </g>
    </svg>
  )
}

export default externalLinkIcon
